module.exports = __webpack_public_path__ + "static/media/video.bccf025.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video.mp4
// module id = 4R5l
// module chunks = 1